import React from "react";
import "./index.scss";

export default function LoginTitle ({title, subtitle}) {
    return <div className="login-title-container">
        <h2>{title}</h2>
        <h3>{subtitle}</h3>
    </div>
}